import { useEvents } from "../../api/hooks";
import { Card, DataTable, DayWindowToggle, ErrorState, LoadingState, NotAvailable, PollEmptyState, RelativeTime, SeverityPill } from "../../components/ui";
import { useUiStore } from "../../store/ui";

export function TrustedAdvisorTab({ environmentId, available, connectedAt }: { environmentId: string; available: boolean; connectedAt: string | undefined }) {
  const window = useUiStore((s) => s.window);
  const setWindow = useUiStore((s) => s.setWindow);
  const events = useEvents(environmentId, "trusted_advisor", window);
  if (!available) return <NotAvailable what="Trusted Advisor" because="without a paid AWS Support plan" why="Reading Trusted Advisor alerts needs a Business or Enterprise support plan." />;
  return (
    <Card title="Trusted Advisor findings">
      <div className="mb-3 flex justify-end"><DayWindowToggle value={window} onChange={setWindow} /></div>
      {events.isPending && <LoadingState />}
      {events.isError && <ErrorState error={events.error} onRetry={() => void events.refetch()} />}
      {events.data && (
        <DataTable
          caption={`Trusted Advisor findings in the last ${window} days`}
          rows={events.data.events}
          rowKey={(e) => e.eventId}
          empty={<PollEmptyState connectedAt={connectedAt} what="Trusted Advisor" title={`No flagged checks in the last ${window} days`} />}
          columns={[
            { key: "when", header: "When", render: (e) => <RelativeTime iso={e.timestamp} /> },
            { key: "check", header: "Check", render: (e) => e.title },
            { key: "sev", header: "Severity", render: (e) => <SeverityPill severity={e.severity} /> },
            { key: "detail", header: "Detail", render: (e) => <span className="text-neutral-600 dark:text-neutral-400">{e.reason ?? ""}</span> },
          ]}
        />
      )}
    </Card>
  );
}
